/**
 * @generated SignedSource<<47440afd20e601db6c045c7836f6a036>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ConnectSlackCurriculumItemBannerFragment$data = {
  readonly viewerHasCompleted: boolean;
  readonly " $fragmentType": "ConnectSlackCurriculumItemBannerFragment";
};
export type ConnectSlackCurriculumItemBannerFragment$key = {
  readonly " $data"?: ConnectSlackCurriculumItemBannerFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConnectSlackCurriculumItemBannerFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConnectSlackCurriculumItemBannerFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerHasCompleted",
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "5400d6fdd6c2b4dbb145f537d42098f8";

export default node;
